// R2 — Weekly Execution (Leading Indicators). Data from GET /v1/bo/weekly-indicators
// (see backoffice.routes.js -> models.weeklyIndicators.getWeeklyIndicators).
// Only ONE of the deck's 4 example indicators is honestly computable today —
// "Tanya/komentar baru komunitas per minggu". The other three (pendaftar pintu
// gratis, pesan retensi terkirim, member MERAH baru minggu ini) need integrations
// or a P2 feature that don't exist yet; the backend reports them in meta.not_available
// instead of faking numbers.
let churnWeeklyIndicatorsSection = {
  name: "Weekly Execution",
  slug: "churnWeeklyIndicators",
  visible: true,
  singularName: "churnWeeklyIndicators",
  crud: true,
  endpoint: "/v1/bo/weekly-indicators",
  updateLabel: "churnWeeklyIndicators",
  meta: {
    delete_flag: false,
  },
  access: ["superadmin"],
  delete: false,
  noNeedSearch: true,
  noNeedRefresh: false,
  add: false,
  update: false,
  edit: false,
  exportToCsv: true,
  fields: [
    {
      label: "Minggu Mulai",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.week_start ? row.week_start : "-"),
    },
    {
      label: "Tanya/Komentar Baru",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.total != null ? row.total : "-"),
    },
    {
      label: "Arah",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.arah ? row.arah : "-"),
    },
  ],
};

export default [churnWeeklyIndicatorsSection];
